<template>
  <Modal appear variant="info" @close="close">
    <template slot="lead">
      <span class="c-text--main">{{ item.name }}を削除します。</span>
    </template>
    <template slot="btns">
      <div class="c-alertPos">
        <Button
          variant="main"
          size="w240"
          fsize="f16"
          :disabled="isDisabled"
          :class="{ 'is-loading': isProcessing }"
          @click="submit"
        >
          はい
        </Button>
        <Alert v-if="request.error" variant="center">
          {{ request.error }}
        </Alert>
      </div>
      <Button
        variant="cancel"
        size="w240"
        fsize="f16"
        :disabled="isDisabled"
        @click="close"
      >
        いいえ
      </Button>
    </template>
  </Modal>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import apiOrganizations from '@/api/organizations';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Modal
  },
  data() {
    return {
      request: {
        error: ''
      },
      isProcessing: false
    };
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isDisabled() {
      return this.isProcessing;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;

      apiOrganizations.users
        .delete(
          this.auth.idToken,
          this.organization.organizationId,
          this.item.userId
        )
        .then(response => {
          this.isProcessing = false;
          this.$emit('delete', this.item);
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
